
import KTSearch from "@/layout/header/partials/Search.vue";
import MenuComponent from "@/components/menu/MenuComponent.vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import KTMyApps from "@/layout/header/partials/MyApps.vue";
import KTNotificationMenu from "@/layout/header/partials/NotificationMenu.vue";
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Decode } from "@/services";
import userApi from "@/api/user/";

export default defineComponent({
  name: "topbar",
  components: {
    KTUserMenu,
    KTMyApps,
    KTNotificationMenu,
    KTSearch,
    MenuComponent,
  },
  setup() {
    const router = useRouter();
    const i18n = useI18n();
    const store = useStore();

    i18n.locale.value = localStorage.getItem("lang")
      ? (localStorage.getItem("lang") as string)
      : "th";

    const countries = {
      en: {
        flag: "media/flags/united-states.svg",
        name: "English",
      },
      th: {
        flag: "media/flags/thailand.svg",
        name: "English",
      },
      es: {
        flag: "media/flags/spain.svg",
        name: "Spanish",
      },
      de: {
        flag: "media/flags/germany.svg",
        name: "German",
      },
      ja: {
        flag: "media/flags/japan.svg",
        name: "Japanese",
      },
      fr: {
        flag: "media/flags/france.svg",
        name: "French",
      },
    };

    const signOut = async () => {
      // store
      //   .dispatch(Actions.LOGOUT)
      //   .then(() => router.push({ name: "authentication-base-sign-in" }));
      await localStorage.clear();
      // router.push("/public");
      router.push("/login");
      // set หน้าแรกตรงนี้
    };

    const setLang = (lang) => {
      localStorage.setItem("lang", lang);
      i18n.locale.value = lang;
    };

    const currentLanguage = (lang) => {
      return i18n.locale.value === lang;
    };

    const currentLangugeLocale = computed(() => {
      return countries[i18n.locale.value];
    });

    return {
      signOut,
      setLang,
      currentLanguage,
      currentLangugeLocale,
      countries,
    };
  },
  data: () => ({
    user: "",
    userName: "",
    userId: "",
    classRole: "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2",
    cssSignOut: "color: #F1416C;",
    // currentLang: localStorage.getItem("lang"),
    currentLang: "",
  }),
  created() {
    this.getAllUser();
    this.getLang();
  },
  methods: {
    getLang() {
      const langa = localStorage.getItem("lang");
      this.currentLang = !langa ? "th" : langa;
    },
    async getAllUser() {
      this.userId = Decode.decode(localStorage.getItem("boss"));
      let responseData = [];

      try {
        responseData = await userApi.user.getOne(this.userId);
      } catch (error) {
        console.log(error);
      }

      if (responseData["response_status"] === "SUCCESS") {
        this.user = responseData["data"];
        this.userName = responseData["data"]["firstName"];
        this.setClassRole();
      }
    },
    setClassRole() {
      this.user["role"] === "SUPER ADMIN"
        ? (this.classRole =
            "badge badge-light-primary fw-bolder fs-8 px-2 py-1 ms-2")
        : this.user["role"] === "ADMIN"
        ? (this.classRole =
            "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2")
        : this.user["role"] === "MANAGER"
        ? (this.classRole =
            "badge badge-light-warning fw-bolder fs-8 px-2 py-1 ms-2")
        : this.user["role"] === "BRANCH MANAGER"
        ? (this.classRole =
            "badge badge-light-danger fw-bolder fs-8 px-2 py-1 ms-2")
        : this.user["role"] === "STAFF"
        ? (this.classRole =
            "badge badge-light-info fw-bolder fs-8 px-2 py-1 ms-2")
        : (this.classRole =
            "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2");
    },

    enterSignOut() {
      this.cssSignOut = "color: #D9214E; background-color: #FFF5F8";
    },

    leaveSignOut() {
      this.cssSignOut = "color: #F1416C;";
    },
  },
});
